var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeDonations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2827 44.7803H9.32609C8.59371 44.7803 8 45.374 8 46.1064V64.6717C8 65.4041 8.59371 65.9978 9.32609 65.9978H17.2827C18.015 65.9978 18.6088 65.4041 18.6088 64.6717V46.1064C18.6088 45.374 18.015 44.7803 17.2827 44.7803Z",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6074 62.1864C30.5423 66.1646 35.6477 68.6497 40.0902 68.6497C46.4554 68.6497 50.7917 64.6529 68.999 55.5559C68.1048 54.3512 66.8619 53.4506 65.4386 52.9762C64.0153 52.5018 62.4806 52.4765 61.0425 52.9037L49.5956 56.5292",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1748 24.8889H68.5688V42.762C68.5688 43.6326 68.2233 44.4676 67.6082 45.0837C66.9931 45.6999 66.1586 46.0467 65.288 46.0481H40.4609C39.5894 46.0481 38.7535 45.7019 38.1373 45.0856C37.521 44.4694 37.1748 43.6335 37.1748 42.762V24.8889Z",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6074 47.4324H26.564C32.8046 47.4324 37.1728 52.7368 38.4988 52.7368H47.7815C50.4337 52.7368 50.4337 58.0411 47.7815 58.0411H33.1945",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8723 41.7461L47.0375 35.646C46.526 35.1346 46.1882 34.4753 46.0721 33.7613C45.9559 33.0473 46.0673 32.3149 46.3904 31.6677C46.6342 31.1771 46.9914 30.7517 47.4325 30.4267C47.8735 30.1017 48.3856 29.8865 48.9264 29.7989C49.4672 29.7112 50.0211 29.7537 50.5422 29.9228C51.0633 30.092 51.5366 30.3828 51.9228 30.7713L52.8776 31.7261L53.8298 30.7713C54.216 30.3823 54.6895 30.0909 55.2109 29.9215C55.7323 29.7521 56.2865 29.7094 56.8277 29.797C57.3689 29.8847 57.8814 30.1001 58.3226 30.4255C58.7639 30.7508 59.1212 31.1767 59.3649 31.6677C59.688 32.3149 59.7993 33.0473 59.6832 33.7613C59.567 34.4753 59.2293 35.1346 58.7177 35.646L52.8723 41.7461Z",
    fill: "#0E5CF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.827 18.1265H65.9166C66.62 18.1265 67.2946 18.4059 67.792 18.9033C68.2893 19.4007 68.5688 20.0752 68.5688 20.7787V24.8895H37.1748V20.7787C37.1748 20.0752 37.4542 19.4007 37.9516 18.9033C38.449 18.4059 39.1236 18.1265 39.827 18.1265V18.1265Z",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8721 17.3626C52.8721 17.3626 55.7152 4.57112 61.3989 7.41161C65.9818 9.7031 59.9826 17.3626 52.8721 17.3626Z",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8727 17.3626C52.8727 17.3626 50.0296 4.57112 44.3353 7.41161C39.7603 9.7031 45.7648 17.3626 52.8727 17.3626Z",
    stroke: "#20242E",
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeDonations);
export default __webpack_public_path__ + "static/media/ic-large-donations.a01d3a8ab3022b2b8ff988fd2c5ca8a2.svg";
export { ForwardRef as ReactComponent };